import React from 'react'

export default function FormLine ({ children }) {
  return (
    <div className='form-line'>
      {children}
    </div>
  )
}
